import { MotionPlugin } from '@vueuse/motion';
import type { App } from 'vue';

export function setupVueMotion(app: App) {
  app.use(MotionPlugin);
}
